import createVueComponent from '../createVueComponent';

const Beaker = createVueComponent('BeakerIcon', [
  ['path', { d: 'M4.5 3h15', key: 'c7n0jr' }],
  ['path', { d: 'M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3', key: 'm1uhx7' }],
  ['path', { d: 'M6 14h12', key: '4cwo0f' }],
]);

export default Beaker;
